import { render } from "./SplitLayout.vue?vue&type=template&id=dc4531aa&scoped=true"
import script from "./SplitLayout.vue?vue&type=script&lang=js"
export * from "./SplitLayout.vue?vue&type=script&lang=js"

import "./SplitLayout.vue?vue&type=style&index=0&id=dc4531aa&scoped=true&lang=css"
import "./SplitLayout.vue?vue&type=style&index=1&id=dc4531aa&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4531aa"]])

export default __exports__